import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconText';
/** Renders an SVG icon. */
const SvgText = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M8 9V8h7v16h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1V8h7v1.5a1 1 0 1 0 2 0V8a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v1a1 1 0 0 0 2 0"
      />
    </svg>
  );
};
SvgText.displayName = displayName;
export default SvgText;
